/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProvideLegacyDisputeReviewRequestV2} from '@cash-web/protos/squareup/cash/payback/api/Disputes.pb'
import {ProvideLegacyDisputeReviewResponseV2} from '@cash-web/protos/squareup/cash/payback/api/Disputes.pb'


export const provideLegacyDisputeReviewV2 = (request: ProvideLegacyDisputeReviewRequestV2, options?: CashRequestOptions) => post<ProvideLegacyDisputeReviewRequestV2, ProvideLegacyDisputeReviewResponseV2>("/2.0/cash/provide-legacy-dispute-review-v2", request, {...options, rejectOnError: true })